import { useDispatch } from 'react-redux';

import { setAttemptedSubmit, setScrollToTransitionConsent } from '@app/redux/changePlan';

export const useConsentCheck = (isEicChecked: boolean, eicRequired: boolean) => {
  const dispatch = useDispatch();

  const checkConsent = () => {
    if (eicRequired && !isEicChecked) {
      dispatch(setAttemptedSubmit(true));
      dispatch(setScrollToTransitionConsent(true));
      return false;
    }
    return true;
  };

  return { checkConsent };
};
